/* istanbul ignore file */
import { useContext } from 'react';
import { Config, ConfigContext } from '../contexts';

export function useConfig<T extends Config>() {
  const context = useContext(ConfigContext);

  return context as T;
}
